import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Radio,
  InputNumber,
  Button,
  Space,
  message,
  notification,
} from "antd";
import data from "./data";
import { instance } from "utils/axios";
import { useNavigate } from "react-router-dom";
import alternative from "../../assets/images/tac.png";
const { provinces, dates } = data;

const ApplicationPage = () => {
  const [form] = Form.useForm();
  const [step, setStep] = useState(1);
  const [guid, setGuid] = useState(null);
  const [formValues, setFormValues] = useState({});
  const navigate = useNavigate();

  // Step 2-т шилжих үед хадгалсан dateCamp-ийг Radio-д set хийх
  useEffect(() => {
    if (step === 2 && formValues.dateCamp) {
      form.setFieldsValue({ dateCamp: formValues.dateCamp });
    }
  }, [step]);

  const onNext = async () => {
    try {
      const values = await form.validateFields();
      setFormValues((prev) => ({ ...prev, ...values }));
      setStep(step + 1);
    } catch (error) {
      const errorMessage =
        error?.errorFields?.[0]?.errors?.[0] ||
        "Алдаа гарлаа. Дахин оролдоно уу.";

      notification.error({
        message: "Мэдээлэлээ гүйцэт оруулна уу",
        description: errorMessage,
        duration: 3,
      });
    }
  };

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      const finalValues = { ...formValues, ...values };

      instance({
        method: "post",
        url: "/admissions/applicant",
        data: { ...finalValues, guid },
      })
        .then((res) => {
          navigate(`/qpay/${res.data.guid}`);
        })
        .catch((err) => {
          if (err.response?.status === 409) {
            notification.error({
              message: "Бүртгэгдсэн байна!",
              description: "Энэ утсан дээр энэ нэрээр бүртгэгдсэн байна",
              duration: 5,
            });
          }
        });
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  const handleFormChange = async (changedValues, allValues) => {
    const { phone, firstName } = allValues;

    if (changedValues.firstName) {
      form.setFieldsValue({ firstName: changedValues.firstName.trim() });
    }
    if (changedValues.lastName) {
      form.setFieldsValue({ lastName: changedValues.lastName.trim() });
    }

    if (!("firstName" in changedValues || "phone" in changedValues)) return;

    const isValidPhone = phone?.toString().length === 8;
    const trimmedFirstName = firstName?.trim();

    if (isValidPhone && trimmedFirstName?.length > 1) {
      try {
        const res = await instance.get(
          `/admissions/applicant?phone=${phone}&firstName=${trimmedFirstName}`
        );
        // Хоосон обьект {} буцсан үед auto-fill хийхгүй
        if (res?.data && Object.keys(res.data).length > 0) {
          const {
            lastName,
            email,
            guid,
            guardianPhone,
            gender,
            province,
            school,
            schoolType,
            grade,
            previousCamp,
            dateCamp,
            code,
          } = res.data;

          // grade нь string эсвэл number байж болно. Radio-той тохирох утга болгох
          let normalizedGrade = grade;
          if (
            grade !== null &&
            grade !== undefined &&
            !isNaN(Number(grade))
          ) {
            normalizedGrade = Number(grade);
          }

          // Хуучин dateCamp шинэ data.js-ын ээлжтэй тохирох эсэхийг шалгах
          const matchedDateCamp = dates.find((d) => d.name === dateCamp)
            ? dateCamp
            : undefined;

          const fillValues = {
            lastName,
            email,
            confirmEmail: email,
            guardianPhone,
            gender,
            province,
            school,
            schoolType,
            grade: normalizedGrade,
            previousCamp,
            dateCamp: matchedDateCamp,
            code,
          };

          // Form дээр шууд set (одоо render-лэгдсэн талбарууд)
          form.setFieldsValue(fillValues);

          // formValues state-д ч мөн хадгалах (Step 2-т шилжихэд алдагдахгүй)
          setFormValues((prev) => ({ ...prev, ...fillValues }));

          setGuid(guid);
          message.success("Өмнөх бүртгэлийн мэдээллийг ачааллав.");
        }
      } catch (err) {
        console.log("Өгөгдөл олдсонгүй эсвэл алдаа гарлаа", err);
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-center bg-cover">
      <div className="p-6 bg-white rounded-lg shadow-lg bg-opacity-60">
        <div className="w-full text-center">
          <div className="flex flex-col items-center text-center mb-8">
            <img
              src={alternative}
              alt="Томүжин Академи"
              className="w-60 md:w-80 lg:w-96 object-contain mt-5"
            />
          </div>
          <h1 className="text-3xl break-normal">Өргөдөл бөглөх</h1>
        </div>
        <Form
          form={form}
          layout="vertical"
          style={{ marginTop: 16 }}
          onFinish={onFinish}
          onValuesChange={handleFormChange}
        >
          {step === 1 ? (
            <div className="">
              <div className="w-full gap-4 md:flex ">
                <Form.Item
                  label="Нэр"
                  name="firstName"
                  className="w-full"
                  rules={[{ required: true, message: "Нэр оруулна уу." }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Овог"
                  className="w-full"
                  name="lastName"
                  rules={[{ required: true, message: "Овогоо оруулна уу." }]}
                >
                  <Input />
                </Form.Item>
              </div>
              <Form.Item
                label="Сурагчийн утасны дугаар"
                name="phone"
                rules={[
                  { required: true, message: "Утасны дугаараа оруулна уу." },
                  {
                    pattern: /^[0-9]{8}$/,
                    message: "8 оронтой зөвхөн тоо оруулна уу.",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="99123456"
                  maxLength={8}
                />
              </Form.Item>
              <Form.Item
                label="Имэйл хаяг"
                name="email"
                rules={[
                  { required: true, message: "Имэйл хаягаа оруулна уу." },
                  { type: "email", message: "Зөв имэйл оруулна уу." },
                ]}
              >
                <Input placeholder="example@example.com" />
              </Form.Item>
              <Form.Item
                label="Имэйлээ дахин оруулна уу"
                name="confirmEmail"
                dependencies={["email"]}
                rules={[
                  { required: true, message: "Имэйлээ давтан оруулна уу." },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("email") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Имэйлүүд тохирохгүй байна!")
                      );
                    },
                  }),
                ]}
              >
                <Input placeholder="example@example.com" />
              </Form.Item>
              <Form.Item
                label="Асран хамгаалагчийн утасны дугаар"
                name="guardianPhone"
                rules={[
                  { required: true, message: "Утасны дугаараа оруулна уу." },
                  {
                    pattern: /^[0-9]{8}$/,
                    message: "8 оронтой зөвхөн тоо оруулна уу.",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="99123456"
                  maxLength={8}
                />
              </Form.Item>
              <Form.Item
                label="Хүйс"
                name="gender"
                rules={[{ required: true, message: "Хүйсээ сонгоно уу." }]}
              >
                <Radio.Group>
                  <Radio value="male">Эрэгтэй</Radio>
                  <Radio value="female">Эмэгтэй</Radio>
                  <Radio value="other">Бусад</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="Та хаанаас Tomujin Summer Camp-ийг зорин ирэх вэ?"
                name="province"
                rules={[{ required: true, message: "Сонгоно уу." }]}
              >
                <Radio.Group>
                  <div className="grid grid-cols-2 md:grid-cols-3">
                    {provinces?.map((item, i) => (
                      <Radio key={`province ${i}`} value={item.name}>
                        {item.name}
                      </Radio>
                    ))}
                  </div>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="Сургуулийн нэр"
                name="school"
                rules={[
                  { required: true, message: "Сургуулийн нэр оруулна уу." },
                ]}
              >
                <Input placeholder="" style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label="Сургуулийн төрөл"
                name="schoolType"
                rules={[
                  { required: true, message: "Сургуулийн төрөл оруулна уу." },
                ]}
              >
                <Radio.Group>
                  <Radio value="Улсын">Улсын</Radio>
                  <Radio value="Хувийн">Хувийн</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="Анги (ирэх намар элсэж орох анги)"
                name="grade"
                rules={[{ required: true, message: "Ангиа сонгоно уу." }]}
              >
                <Radio.Group>
                  <div className="grid grid-cols-2">
                    <Radio value={6}>6</Radio>
                    <Radio value={7}>7</Radio>
                    <Radio value={8}>8</Radio>
                    <Radio value={9}>9</Radio>
                    <Radio value={10}>10</Radio>
                    <Radio value={11}>11</Radio>
                    <Radio value={12}>12</Radio>
                    <Radio value={"Анхны өнжих жил"}>Анхны өнжих жил</Radio>
                    <Radio value={"Хоёр ба түүнээс дээш удаагийн өнжих жил"}>
                      Хоёр ба түүнээс дээш удаагийн өнжих жил
                    </Radio>
                  </div>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="Та өмнө нь Tomujin Summer Camp-д авч байсан уу?"
                name="previousCamp"
                rules={[{ required: true, message: "Сонгоно уу." }]}
              >
                <Radio.Group>
                  <Radio value="yes">Тийм</Radio>
                  <Radio value="no">Үгүй</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item className="mt-6 border-t-2 border-[#5c1090] justify-end flex">
                <Button type="primary" className="mt-6" onClick={onNext}>
                  Үргэжлүүлэх
                </Button>
              </Form.Item>
            </div>
          ) : (
            <div>
              <Form.Item
                label="Та Tomujin Summer Camp-ийн хэддүгээр ээлжинд хамрагдах хүсэлтэй байна вэ?"
                name="dateCamp"
                rules={[
                  { required: true, message: "Ээлжээ сонгоно уу." },
                ]}
              >
                <Radio.Group>
                  <div className="grid justify-between grid-cols-1 md:grid-cols-2">
                    {dates?.map((item, i) => (
                      <Radio key={`date shift ${i}`} value={item.name}>
                        {item.name}
                      </Radio>
                    ))}
                  </div>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="Танд Summer Camp-ыг санал болгогчийн код "
                name="code"
              >
                <Input placeholder="(Байхгүй бол хоосон орхино уу.)" />
              </Form.Item>
              <Form.Item className="mt-6 border-t-2 border-[#5c1090] ">
                <div className="flex justify-between w-full">
                  <Button
                    type="primary"
                    className="mt-6"
                    onClick={() => setStep(step - 1)}
                  >
                    Буцах
                  </Button>

                  <Button type="primary" className="mt-6" htmlType="submit">
                    Үргэлжлүүлэх
                  </Button>
                </div>
              </Form.Item>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

export default ApplicationPage;